import React from "react"

import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material"

import {
    MatesMultilineTextField,
    MatesSelect,
    withUseFormHook,
} from "@sinossi/mates-react-library"

import {
    Trans,
    t,
} from "@lingui/macro"
import { UseFormReturn } from "react-hook-form"

import { AssetMatchesBrandRejectReason } from "models/asset-match-brand"

import RefuseModalValidation, { RefuseModalForm } from "./refuse-modal-form"

interface RefuseMatchModalProps extends UseFormReturn
{
    closeModal: () => void
    callback: (values: RefuseModalForm) => void
}
interface RefuseMatchModalState
{
}
class RefuseMatchModal extends React.Component<RefuseMatchModalProps, RefuseMatchModalState>
{
    private submitForm = (values: any) => {
        this.props.callback(values as RefuseModalForm)
    }

    render()
    {
        return (
            <Dialog
                open={true}
                onClose={() => this.props.closeModal()}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>
                    <Typography variant="h5">
                        <Trans id="md-refuse-match-modal-title">Descrivi il motivo del tuo rifiuto</Trans>
                    </Typography>
                </DialogTitle>
                <form onSubmit={this.props.handleSubmit(this.submitForm)}>
                    <DialogContent>
                        <Typography variant="body1" sx={{ mb: 5, fontWeight: "light" }}>
                            <Trans id="md-refuse-match-modal-text">La tua opinione sarà fondamentale per ottimizzare i prossimi risultati</Trans>
                        </Typography>
                        <MatesSelect
                            required
                            variant={"outlined"}
                            label={t({
                                id: "md-match-refuse-reason",
                                message: "Motivo",
                            })}
                            name="reason"
                            control={this.props.control}
                            trigger={this.props.trigger}
                            formState={this.props.formState}
                        >
                            {Object.keys(AssetMatchesBrandRejectReason).map(item =>
                                <option value={item}>
                                    <Trans id={"enums.match-reject-reasons." + item}>
                                    </Trans>
                                </option>
                            )}
                        </MatesSelect>

                        <MatesMultilineTextField
                            sx={{
                                mt: 3
                            }}
                            maxLength={1024}
                            minRows={10}
                            maxRows={10}
                            required
                            variant={"outlined"}
                            label={t({
                                id: "md-match-refuse-reason-text",
                                message: "Descrizione del rifiuto",
                            })}
                            name="description"
                            control={this.props.control}
                            trigger={this.props.trigger}
                            formState={this.props.formState} />
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={this.props.closeModal}
                                variant={"contained"}
                                color="neutral"
                                sx={{
                                    textTransform: "none",
                                    mr: 1,
                                    width: 100
                                }}
                                disableElevation
                        >
                            <Trans id={"md-refuse-match-close-button"}>
                                Annulla
                            </Trans>
                        </Button>
                        <Button type="submit"
                                variant="contained"
                                sx={{
                                    backgroundColor: 'secondary.main',
                                    color: 'white',
                                    mr: 1,
                                    textTransform: "none",
                                    width: 100
                                }}
                                disabled={!this.props.formState.isValid}
                        >
                            <Trans id={"md-refuse-match-confirm-button"}>Conferma</Trans>
                        </Button>

                    </DialogActions>
                </form>
            </Dialog>
        )
    }
}

export default withUseFormHook<RefuseModalForm>(
    RefuseMatchModal,
    RefuseModalValidation,
    new RefuseModalForm()
)
